
import React from "react";
import { CheckCircle, AlertTriangle, LineChart, Bell } from "lucide-react";
import VerifiedIcon from '@mui/icons-material/Verified';
import Tooltip from '@mui/material/Tooltip';



const ContractCard = ({
  contract,
  isSubscribed,
  onSubscribe,
  onViewProfile,
  onViewContract,
  onViewProduct,
  onViewAssetDetails,
  onViewResult,
  onViewLineage,
  activeTab
}) => {
  // Replace | with . in asset name
  const formatAssetName = (name) => {
    return name ? name.replace(/\|/g, '.') : name;
  };

  const getDataLayerClass = (dataLayer) => {
    switch (dataLayer) {
      case 'bronze':
        return 'bronze';
      case 'gold':
        return 'gold';
      case 'silver':
        return 'silver';
      case 'ingestion':
        return 'ingestion';
      default:
        return '';
    }
  };

  return (
    <div key={contract.id} className="contract-card">
      <div className="card-header bg-[#bb1ccc]/5">
        <div className="header-content">
          <div>
            <div className="card-title">
              <div className="flex items-center">
              <Tooltip title="Data Steward Certified" placement="top">
                            <VerifiedIcon  sx={{marginRight:"5px", color: "#A5DB00"}} /> 
                          </Tooltip> 
              <h3 style={{ color: '#bb1ccc', fontWeight: 'bold' }}>{formatAssetName(contract.name)}</h3>
              </div>
              {/* Data Layer Tag */}
              {contract.dataLayer && (
                <span className={`data-layer-tag ${getDataLayerClass(contract.dataLayer)} p-1 border-xl rounded`}>
                  {contract.dataLayer.charAt(0).toUpperCase() + contract.dataLayer.slice(1).toLowerCase()}
                </span>
              )}
              <div className="bg-yellow-100 p-1 border-xl text-yellow-700 rounded" style={{ fontSize: '10px', marginLeft: '8px'}}>Version {contract?.version}</div>
              {/* Tags removed - no more type, status, tablesCount */}
            </div>
            {/* <p className="card-version">Version {contract.version}</p> */}
          </div>
          <div className="quality-score">
            <div className="score-label">Quality Score</div>
            <div className="score-value" style={{color:'#bb1ccc'}}>{contract.qualityScore}%</div>
          </div>
        </div>

        <div className="card-meta">
          <div className="meta-item">
            <span className="meta-label">Owner:</span>
            <span className="meta-value font-bold">{contract.owner}</span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Last Updated:</span>
            <span className="meta-value font-bold">{contract.lastUpdated}</span>
          </div>
        </div>
      </div>

      <div className="card-body">
        <p className="card-description" style={{fontSize: '13px'}}>{contract.description}</p>

        <div className="stats-grid">
          {/* <div className="stat-item">
            <CheckCircle className="icon success" />
            <div>
              <div className="stat-label">Profile Status</div>
              <div className="stat-value font-bold">Last profiled: {contract.profileStatus}</div>
            </div>
          </div> */}
          <div className="stat-item">
            <AlertTriangle className="icon warning" />
            <div>
              <div className="stat-label">DQ Issues</div>
              <div className="stat-value font-bold">{contract.issues.count} rules failing</div>
            </div>
          </div>
          <div className="stat-item">
            <LineChart className="icon info" />
            <div>
              <div className="stat-label">DQ Trend</div>
              <div className="stat-value font-bold">{contract.dqTrend}</div>
            </div>
          </div>
        </div>

        <div className="card-actions">
          <div className="action-links">
            <button
              className="link-button bg-blue-100 text-blue-700 border border-blue-400"
              onClick={onViewProduct}
            >
              View Product
            </button>
            <button
              className="link-button bg-green-100 text-green-700 border border-green-400"
              onClick={onViewAssetDetails}
            >
              View Asset Details
            </button>
            <button
              className="link-button text-purple-700 border border-purple-400 bg-purple-100"
              onClick={onViewResult}
            >
              View Result
            </button>
            <button
              className="link-button bg-orange-100 text-orange-700 border border-orange-400 "
              onClick={onViewLineage}
                            // disabled={true}

            >
              {/* <GitBranch className="icon" /> */}
              View Lineage
            </button>
            <button
              className="link-button bg-indigo-100 text-indigo-700 border border-indigo-400"
              onClick={onViewContract}
            >
              View Contract
            </button>
          </div>
          {activeTab === "all" && (
            <button
              onClick={onSubscribe}
              className="px-4 py-2 rounded bg-[#bb1ccc] text-white flex text-center"
              title="Request Access to make your product event driven"
            >
              <Bell className="icon" />
              <span style={{ marginLeft: '8px'}}>Subscribe</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContractCard;
